import { List, ListItem, Paper, Typography } from '@mui/material'
import React from 'react'
import styles1 from '../../styles/pages/memberEditors.module.scss'
import styles from '../../styles/pages/editors.module.scss'
import styles2 from "../../styles/pages/buyer-list.module.scss";



// interface VideosummaryProps {
//     children ,
//     videoTitle ,
//     countVideo: string
// }

const VideosummaryCardPartner = (props) => {
    const { children } = props
    return (
        <>
            <Paper className={`${styles.videoSummaryCard} glbvdoCard ${styles1.videoSummaryCard} ${styles2.videoSummaryCard}`}>
                <Typography variant='h4'>{props?.videoTitle} <span>{props?.countVideo}</span></Typography>
                {children}
            </Paper>
        </>
    )
}

export default VideosummaryCardPartner